import { render, staticRenderFns } from "./WhyOptionsArentShowing.vue?vue&type=template&id=09094472&scoped=true"
import script from "./WhyOptionsArentShowing.vue?vue&type=script&lang=js"
export * from "./WhyOptionsArentShowing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09094472",
  null
  
)

export default component.exports